import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        activePanel: 'home',
        lastActivePanel: '',

        historyDepth: 0,
        historyMaxDepth: 0,
        historyScroll: {},

        launchParams: '',
        launchURL: '',
        device: '',
        user: {},

        isOffline: false,

        showBoard: 0,

        timeoutFromLastAction: null,

        moonDayInfo: {},
        horoscopes: {},

        favoriteButton: {
            result: null,
            message: "",
        },

        addCommunityButton: {
            result: null,
            message: "",
        },
    },
    mutations: {
        setNewHistoryScroll(state, panel) {
            state.historyScroll[panel["panel"]] = panel["scroll"];
        },

        deleteHistoryScroll(state, panel) {
            delete state.historyScroll[panel];
        },

        setActivePanel(state, panel) {
            state.activePanel = panel;
        },

        setLastActivePanel(state, panel) {
            state.lastActivePanel = panel;
        },

        setHistoryDepth(state, value) {
            state.historyDepth = value;
        },

        setLaunchParams(state, params) {
            state.launchParams = params;
        },

        setLaunchURL(state, params) {
            state.launchURL = params;
        },

        setIsOffline(state, value) {
            state.isOffline = value;
        },

        setUser(state, user) {
            state.user = user;
        },

        setShowBoard(state, value) {
            state.showBoard = value;
        },

        setTimeoutFromLastAction(state, value) {
            state.timeoutFromLastAction = value;
        },

        setMoonDayInfo(state, value) {
            state.moonDayInfo = value;
        },

        setHoroscope(state, value) {
            state.horoscopes[value["sign"]] = value["text"];
        },

        setFavoriteButton(state, resultObj) {
            state.favoriteButton.result = resultObj.result;
            state.favoriteButton.message = resultObj.message;
        },

        setAddCommunityButton(state, resultObj) {
            state.addCommunityButton.result = resultObj.result;
            state.addCommunityButton.message = resultObj.message;
        },

    },
    actions: {
        setIsOffline(context) {
            context.commit("setIsOffline");
        },
    },
    getters: {
    },
    modules: {
    }
});